export interface LoanCondition {
  id: string
  description: string
  priority: 'high' | 'medium' | 'low'
}

export interface LoanNote {
  text: string
  date: string
  author: string
}

export interface Loan {
  id: string
  borrowerName: string
  phoneNumber: string
  loanAmount: number
  loanType: 'Purchase' | 'Refinance' | 'HELOC'
  outstandingConditions: LoanCondition[]
  mostRecentNote: LoanNote
}

export interface ProcessedLoan {
  loan: Loan
  action: 'called' | 'noted' | 'snoozed'
  disposition?: 'contacted' | 'no_answer' | 'voicemail'
  note?: string
  followUpTime?: string
  snoozeUntil?: string
  processedAt: string
}

export const mockLoans: Loan[] = [
  {
    id: 'LN-10045',
    borrowerName: 'Sarah Jenkins',
    phoneNumber: '(555) 234-5678',
    loanAmount: 450000,
    loanType: 'Purchase',
    outstandingConditions: [
      { id: 'c1', description: 'Missing W-2 for 2022', priority: 'high' },
      {
        id: 'c2',
        description: 'Letter of Explanation for recent credit inquiry',
        priority: 'medium',
      },
    ],
    mostRecentNote: {
      text: 'Left a voicemail yesterday asking for the W-2. Borrower said they would upload it by EOD.',
      date: '2023-10-24T14:30:00Z',
      author: 'Mike Processor',
    },
  },
  {
    id: 'LN-10082',
    borrowerName: 'David & Emily Chen',
    phoneNumber: '(555) 987-6543',
    loanAmount: 620000,
    loanType: 'Refinance',
    outstandingConditions: [
      {
        id: 'c3',
        description: 'Appraisal requires minor roof repairs prior to close',
        priority: 'high',
      },
      {
        id: 'c4',
        description: 'Updated Homeowners Insurance Declaration Page needed',
        priority: 'high',
      },
    ],
    mostRecentNote: {
      text: 'Sent email requesting the updated HOI. Waiting on contractor invoice for the roof.',
      date: '2023-10-23T09:15:00Z',
      author: 'Sarah Processor',
    },
  },
  {
    id: 'LN-10105',
    borrowerName: 'Marcus Johnson',
    phoneNumber: '(555) 333-4444',
    loanAmount: 150000,
    loanType: 'HELOC',
    outstandingConditions: [
      {
        id: 'c5',
        description: 'Verify employment with current HR department',
        priority: 'medium',
      },
    ],
    mostRecentNote: {
      text: 'HR department phone line was busy. Need to try again today.',
      date: '2023-10-25T08:00:00Z',
      author: 'System',
    },
  },
  {
    id: 'LN-10112',
    borrowerName: 'Jessica Alba',
    phoneNumber: '(555) 111-2222',
    loanAmount: 385000,
    loanType: 'Purchase',
    outstandingConditions: [
      {
        id: 'c6',
        description: 'Clear to Close pending final verbal VOE',
        priority: 'high',
      },
      {
        id: 'c7',
        description: 'Sign initial closing disclosure',
        priority: 'high',
      },
    ],
    mostRecentNote: {
      text: 'CD was sent out yesterday. Need borrower to acknowledge so we can start the 3-day timer.',
      date: '2023-10-25T10:45:00Z',
      author: 'Mike Processor',
    },
  },
  {
    id: 'LN-10150',
    borrowerName: 'Robert Baratheon',
    phoneNumber: '(555) 777-8888',
    loanAmount: 850000,
    loanType: 'Refinance',
    outstandingConditions: [
      {
        id: 'c8',
        description: 'Two months consecutive bank statements (all pages)',
        priority: 'medium',
      },
      {
        id: 'c9',
        description:
          'Title commitment shows outstanding lien to be paid at close',
        priority: 'low',
      },
    ],
    mostRecentNote: {
      text: 'Borrower uploaded bank statements but missed page 4 of 4 on both months.',
      date: '2023-10-22T16:20:00Z',
      author: 'Sarah Processor',
    },
  },
  {
    id: 'LN-10177',
    borrowerName: 'Amanda Ripley',
    phoneNumber: '(555) 444-5555',
    loanAmount: 290000,
    loanType: 'Purchase',
    outstandingConditions: [
      {
        id: 'c10',
        description: 'Gift letter signed by donor',
        priority: 'high',
      },
      {
        id: 'c11',
        description: 'Proof of wire transfer for earnest money deposit',
        priority: 'medium',
      },
    ],
    mostRecentNote: {
      text: 'Spoke with Amanda, she is having her father sign the gift letter tonight.',
      date: '2023-10-24T11:10:00Z',
      author: 'Mike Processor',
    },
  },
  {
    id: 'LN-10192',
    borrowerName: 'Thomas Anderson',
    phoneNumber: '(555) 000-1111',
    loanAmount: 510000,
    loanType: 'Purchase',
    outstandingConditions: [
      {
        id: 'c12',
        description: 'Condo questionnaire completed by HOA',
        priority: 'high',
      },
      {
        id: 'c13',
        description: 'Master insurance policy for condo building',
        priority: 'high',
      },
    ],
    mostRecentNote: {
      text: 'HOA is unresponsive. Need borrower to step in and call the property manager.',
      date: '2023-10-25T09:30:00Z',
      author: 'Sarah Processor',
    },
  },
  {
    id: 'LN-10204',
    borrowerName: 'Bruce Wayne',
    phoneNumber: '(555) 888-9999',
    loanAmount: 1200000,
    loanType: 'Refinance',
    outstandingConditions: [
      {
        id: 'c14',
        description: 'K-1s for all businesses owned',
        priority: 'high',
      },
      {
        id: 'c15',
        description: 'YTD Profit and Loss statement',
        priority: 'medium',
      },
    ],
    mostRecentNote: {
      text: 'CPA said they would send the K-1s directly to us by Friday.',
      date: '2023-10-20T15:00:00Z',
      author: 'Mike Processor',
    },
  },
]
